import { render, staticRenderFns } from "./TargetDuration.vue?vue&type=template&id=b83a9ef2&scoped=true"
import script from "./TargetDuration.vue?vue&type=script&lang=js"
export * from "./TargetDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83a9ef2",
  null
  
)

export default component.exports